import React from 'react';
import Enquiry from "../components/enquiry/Enquiry";

const EnquiryPage = () => {
    return (
        <div>
            <Enquiry />
        </div>
    );
};

export default EnquiryPage;
